import {
    AuthActionTypes,
    AuthState,
    LOGIN,
    SET_USER,
    GET_SESSION,
    GET_SESSION_SUCCESS,
    GET_SESSION_ERROR,
    UPDATE_SESSION_FETCHED_STATE,
    LOGOUT,
} from './types';

const initialState: AuthState = {
    isUserLoggedIn: false,
    user: null,
    sessionHasBeenFetched: false,
};

export default function authReducer(
    state: AuthState = initialState,
    action: AuthActionTypes,
): AuthState {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                isUserLoggedIn: true,
            };
        case SET_USER:
            return {
                ...state,
                user: action.payload.user,
            };
        case GET_SESSION:
            return {
                ...state,
                sessionHasBeenFetched: false,
            };
        case GET_SESSION_SUCCESS:
            return {
                ...state,
                sessionHasBeenFetched: true,
                user: action.payload.user,
            };
        case GET_SESSION_ERROR:
            return {
                ...state,
                sessionHasBeenFetched: true,
            };

        case UPDATE_SESSION_FETCHED_STATE:
            return { ...state, sessionHasBeenFetched: true };
        case LOGOUT:
            return {
                ...state,
                sessionHasBeenFetched: true,
            };
        default:
            return { ...state };
    }
}
